
import { defineComponent } from 'vue';
import { IInvoice, IOrder } from '@/types/models';
import api from '@/api/my/invoices';

const $statusDefault = 'Default';
const $statusDelivered = 'Delivered';
const $statusCancellation = 'Cancellation';

interface IState {
  items: IInvoice[];
  isInvoice: boolean;
  invoice?: IInvoice;
  order?: IOrder;
}

export default defineComponent({
  name: 'ListInvoice',
  data() {
    return {
      items: [],
      isInvoice: false,
      invoice: undefined,
      order: undefined,
    } as IState;
  },
  methods: {
    getInvoiceStatus(status: string) {
      if (status === $statusDefault) {
        return '待开发票';
      }
      if (status === $statusDelivered) {
        return '已寄出';
      }
      if (status === $statusCancellation) {
        return '作废发票';
      }
      return '待开发票';
    },

    btnResourceClick(order: IOrder) {
      if (order.resourceType === 'Service') {
        window.open('/vip/#pricing');
      }
    },

    btnViewClick(invoice: IInvoice) {
      this.invoice = invoice;
      this.isInvoice = true;
    },
  },
  mounted() {
    api.get(
      {
        isApply: false,
      },
      (res) => {
        if (!res) return;
        this.items = res.items;
      },
    );
  },
});
